import React, { ComponentType, FunctionComponent } from 'react';
import EvaluationLeadWizardBlock from '../../templates/common/evaluation-lead-wizard-block/EvaluationLeadWizardBlock';
import SavingCalculatorBlock from '../../templates/common/saving-calculator-block/SavingCalculatorBlock';
import AdvFluidAdapter from '../adv-fluid-adapter/AdvFluidAdapter';
import ArticleBlock from '../article-block/ArticleBlock';
import ImageAdapter from '../image-adapter/ImageAdapter';

const ComponentByType: { [key: string]: ComponentType } = {
  ArticleBlock,
  ImageBlock: ImageAdapter,
  AdvFluid: AdvFluidAdapter,
  EvaluationLeadWizard: EvaluationLeadWizardBlock,
  SavingCalculator: SavingCalculatorBlock,
};

export interface GraphCMSRendererProps {
  __typename: string,
}

const GraphCMSRenderer: FunctionComponent<GraphCMSRendererProps> = ({
  __typename,
  ...rest
}) => {
  const Component = ComponentByType[__typename];

  return Component
    ? <Component {...rest} />
    : null;
};

export default GraphCMSRenderer;
